import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IScanningPrefix, ScanningPrefixService } from '@shared/services/scanning-prefix.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-update-scanning-prefix',
	templateUrl: './update-scanning-prefix.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class UpdateScanningPrefixComponent implements OnInit {
	@Output() updated: EventEmitter<any> = new EventEmitter();
	form: FormGroup;
	loading: boolean = false;
	scanningPrefix: IScanningPrefix;

	httpError: string = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public editScanningPrefix: IScanningPrefix,
		public dialogRef: MatDialogRef<UpdateScanningPrefixComponent>,
		private service: ScanningPrefixService,
		private fb: FormBuilder,
	) {
		this.scanningPrefix = { ...editScanningPrefix };
	}

	ngOnInit(): void {
		this.initializeForm();
	}

	initializeForm(): void {
		this.form = this.fb.group({
			prefix: [this.scanningPrefix.prefix, [Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.RFIDCharacters)]],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.scanningPrefix) {
					this.scanningPrefix[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	async onSave() {
		if (this.loading) return;
		this.httpError = '';

		if (this.form.valid) {
			this.loading = true;
			this.service.update(this.scanningPrefix).subscribe({
				next: (response) => {
					this.updated.emit(response);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
